class ProductCarouselTabs extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleTabChange = this.handleTabChange.bind(this)
    this.handleRecommendationsEmpty =
      this.handleRecommendationsEmpty.bind(this)

    this.addEventListener(
      'recommendations:empty',
      this.handleRecommendationsEmpty,
    )

    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTabChange)

      if (triggerEl.dataset.tabType === 'smart') {
        this.externalEls.recommendationsTrigger?.element?.addEventListener(
          'click',
          (event) => {
            triggerEl.click()
            triggerEl.scrollIntoView({ behavior: 'smooth', block: 'start' })
          },
        )
      }
    })
  }

  handleTabChange (event) {
    const clickedTrigger = event.target

    this.els.trigger.elements.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-pressed',
        triggerEl.dataset.index === clickedTrigger.dataset.index,
      )
    })

    this.els.link?.elements.forEach((linkEl) => {
      linkEl.setAttribute(
        'aria-hidden',
        linkEl.dataset.index !== clickedTrigger.dataset.index,
      )
    })

    this.els.panel?.elements.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.index !== clickedTrigger.dataset.index,
      )
    })
  }

  handleRecommendationsEmpty (event) {
    const index = event.detail.index

    const trigger = this.els.trigger?.elements.find(
      (triggerEl) => triggerEl.dataset.index === index,
    )
    if (trigger) {
      trigger.style.display = 'none'
    }

    const link = this.els.link?.elements.find(
      (linkEl) => linkEl.dataset.index === index,
    )
    if (link) {
      link.style.display = 'none'
    }

    const panel = this.els.panel?.elements.find(
      (panelEl) => panelEl.dataset.index === index,
    )
    if (panel) {
      panel.style.display = 'none'
    }

    // If this was the active tab, switch to the first visible tab
    if (trigger && trigger.getAttribute('aria-pressed') === 'true') {
      const firstVisibleTrigger = this.els.trigger?.elements.find(
        (triggerEl) => triggerEl.style.display !== 'none',
      )
      if (firstVisibleTrigger) {
        firstVisibleTrigger.click()
      }
    }
  }
}

if (!customElements.get('product-carousel-tabs')) {
  customElements.define('product-carousel-tabs', ProductCarouselTabs)
}
